import { render, staticRenderFns } from "./EditTeacher.vue?vue&type=template&id=5814c791&"
import script from "./EditTeacher.vue?vue&type=script&lang=js&"
export * from "./EditTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports